import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import VueMoment from 'vue-moment';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Axios from 'axios';
import LoginHub from './login-hub'
import Confirm from '@/components/Confirm'; 
 
import VCurrencyField from 'v-currency-field'

Vue.use(VCurrencyField, { 
	locale: 'es-CL',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0
})
Vue.use(VueMoment, moment);
Vue.component('Confirm', Confirm);
 
Vue.prototype.$http = Axios;
Vue.config.productionTip = false

// Axios Configuration
Axios.defaults.headers.common.Accept = 'application/json';
Axios.defaults.baseURL = process.env.VUE_APP_API_URL; // `https://gasco.smartoffer.cl/api/`;// `http://64.227.13.230/api/`;  https://gasco.smartoffer.cl/api/ `https://localhost:5001/api/`
// Si usas axios
Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
Axios.defaults.headers.common['Content-Type'] = 'application/json';

// Si la API requiere credenciales
Axios.defaults.withCredentials = true;
Vue.use(LoginHub)

let isRefreshingToken = false;
// Request
Axios.interceptors.request.use(
  (config) => {

    let token = localStorage.getItem('jwt');
    if (token) {
      config.headers['Authorization'] = `Bearer ` + token;
    }
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // TODO: check if have any lang saved in localStorage, if not browser lang or default
    // config.headers['Accept-Language'] = 'en';
    return config;
  },
  (error) => {
    return Promise.reject(error);

  }
);
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

Axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const {
    config,
    response: {
      status
    }
  } = error;
  const originalRequest = config;
  if ((error.response.status === 401 && error.response.data === 'invalid_grant') 
  || (error.response.status === 400 && error.response.data === 'invalid_grant')
  || (error.response.status === 500)
  ) {


    localStorage.removeItem('jwt');
    Vue.prototype.stopSignalR();
    window.location.href = '/';
  }
  if (status === 401) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;


      store.dispatch('refreshToken').then((response) => {
        // console.log(response)
        isAlreadyFetchingAccessToken = false;
        let token = response.data.token;
        onAccessTokenFetched(token);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        let headerAuth = `bearer ` + response.data.token;
        store.dispatch('saveToken', token);
        Axios.defaults.headers['Authorization'] = headerAuth;
        originalRequest.headers['Authorization'] = headerAuth;
        isRefreshingToken = false;

        return Axios(originalRequest);
      }).catch((error) => {
        store.dispatch('logout').then(() => {
          router.push({
            name: 'login'
          });
        }).catch(() => {
          router.push({
            name: 'login'
          });
        }).finally(
          () => {

            isRefreshingToken = false;
          }
        );
      });
    }

    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber(access_token => {
        originalRequest.headers.Authorization = `bearer ` + access_token;
        resolve(Axios(originalRequest));
      });
    });
    return retryOriginalRequest;
  }


  return Promise.reject(error);
});



new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
